<template>
  <div
    class="table-search-container"
  >
    <a-input-search
      placeholder="请输入搜索内容"
      style="width:225px;"
      @search="value => $emit('onSearch', value)"
    />
    <!-- <a-button
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      新增推广员
    </a-button> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {

  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
    margin-left: 20px;
  }
}
</style>
